// İSG uzmanı portalı — liste sayfalarının "Daha fazla filtre" açma/kapama düğmesi (owner review
// B2 item 2, 2026-09-28). İş İzinleri'nde 8 filtre 2 satıra taşıyordu (4 birincil + 4 tarih) —
// birincil filtreler HER ZAMAN tek satırda kalır, tarih filtreleri bu düğmenin ARKASINA katlanır.
// Aynı desen Risk Değerlendirme'de de (from/to) kullanılır — iki sayfanın TEK ortak kopyası,
// `TabPanelIntro.tsx`/`FilterChipGroup.tsx` emsalleriyle AYNI ("app-local, birden çok sayfa
// tüketir" — `components/` kökü).
//
// **`activeCount`** — gizli filtrelerden kaçının DOLU olduğu (rozet, yalnız >0 iken görünür,
// `Tag color="blue"` — sayısal rozet için depoda ZATEN kurulu ton, ör. `admin.roles.badge.
// systemAdmin`). **`aria-controls` KASITLI OLARAK YOK** — kontrol edilen bölge birden çok ayrı
// `TableToolbarFilter` kardeşi (tek bir DOM düğümü DEĞİL); `aria-expanded` tek başına durumu
// taşır (WAI-ARIA "Disclosure" deseninin `aria-controls`SUZ de geçerli hâli).

import { Button, Tag, cn } from '@isgportal/shared';
import { ChevronDown, SlidersHorizontal } from 'lucide-react';

export function MoreFiltersToggle({
  open,
  onToggle,
  activeCount,
  label,
}: {
  open: boolean;
  onToggle: () => void;
  /** Şu an dolu olan GİZLİ filtre sayısı — 0 ise rozet hiç render edilmez. */
  activeCount: number;
  label: string;
}) {
  return (
    <Button type="button" variant="ghost" size="sm" aria-expanded={open} onClick={onToggle}>
      <SlidersHorizontal className="h-4 w-4" aria-hidden="true" />
      {label}
      {activeCount > 0 ? (
        <Tag color="blue" className="h-5 px-1.5 text-[11px] leading-4">
          {activeCount}
        </Tag>
      ) : null}
      <ChevronDown
        className={cn('h-4 w-4 transition-transform', open && 'rotate-180')}
        aria-hidden="true"
      />
    </Button>
  );
}
